<template>
	<el-table ref="table" :height="height" style="width: 100%" v-loading="loading"
		:class="'tq-table-wrapper-size-' + lineHeight" element-loading-text="正在努力加载数据中，请稍后......"
		element-loading-spinner="el-icon-loading" v-bind="{ ...$attrs, ...$props }"
		:headerCellClassName="headerCellClassNameComputed" :cellClassName="cellClassNameComputed"
		@sort-change="getSortData" @header-dragend="onTableHeaderChange">
		<template v-if="columnsComputed && columnsComputed.length > 0">
			<el-table-column v-for="item in columnsComputed" :key="item.prop" :prop="item.prop"
				:align="item.align || 'center'"
				:popSlotName="item.popSlotName" :type="item.type" :index="item.index" :width="item.width"
				:sortable="item.sortable"
				:show-overflow-tooltip="item.showOverflowTooltip === false ? false : item.showOverflowTooltip || tableShowTooltip"
				:ellipsisLineNumber="item.ellipsisLineNumber" :fixed="item.fixed" :render-header="item.renderHeader"
				:resizable="item.resizable" :formatter="item.formatter" :class-name="item.className"
				:selectable="item.selectable" :reserve-selection="item.reserveSelection" :label="item.label"
				:min-width="item.minWidth">
				<template v-if="$slots[item.prop]" #default="scope">
					<slot :name="item.prop" :row="scope.row" :index="scope.$index"></slot>
				</template>
			</el-table-column>
		</template>
		<slot v-else></slot>
		<template #empty>
			<slot name="empty">
				<div class="tq-empty-table">
					<div class="empty-icon">
						<img src="../../../assets/images/img_empty.png" />
					</div>
					<div class="empty-text">
						<span>{{ emptyText }}</span>
					</div>
				</div>
			</slot>
		</template>
	</el-table>
</template>

<script lang="ts">
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import ComponentsPlus from "@cttq/ui-components-plus-pc"
import CustomColumns from "../../CustomColumns/index"
import { $customSet } from '../../../utils/tools'
export default {
	name: "TqTable",
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
		border: {
			type: Boolean,
			default: true,
		},
		hiddenCustomIcon: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "default",
		},
		emptyText: {
			type: String,
			default: "暂无数据",
		},
		height: {
			type: [String, Number],
			default: "100%",
		},
		stripe: {
			type: Boolean,
			default: true,
		},
		columns: {
			type: Array,
			default() {
				return []
			},
		},
		cellClassName: {
			type: [String, Function],
			default: "tq-table-cell",
		},
		headerCellClassName: {
			type: [String, Function],
			default: "tq-table-header",
		},
		tableShowTooltip: {
			type: Boolean,
			default: false,
		},
		// 自定义列
		operation: {
			type: Boolean,
			default: false,
		},
		// 自定义缓存key
		cacheKey: String,
		// 最大宽度
		columnMaxWidth: { type: Number, default: 1000 },
	},
	data() {
		return {
			customColumns: [],
			projectPath: "",
			personCode: "",
			lineHeight: "normal",
			originCellClassName: this.cellClassName,
			operationComponent: {
				onTableHeaderChange: (newWidth:number, column:any) => {
					this.onTableHeaderChange(newWidth, 0, column)
				},
				$el: null,
				visibleDialog: false
			},
		}
	},
	created() {
		this.customColumns = this.getColumnsStorage()
	},
	mounted() {
		this.operation && this.createColumnOperation()
	},
	computed: {
		columnsComputed():any {
			const arr:any = []
			this.customColumns.forEach((item:any) => {
				!item.columnHidden && arr.push(item as never)
			})
			return arr
		},
		isDefaultSize() {
			return this.size === 'default'
		},
		headerCellClassNameComputed() {
			return `tq-table-header ${this.isDefaultSize ? 'default-size' : ''}`
		},
		cellClassNameComputed() {
			return `${this.isDefaultSize ? 'text-medium' : ''} tq-table-cell`
		}
	},
	methods: {
		redrawTable() {
			// 再重绘
			setTimeout(() => {
				console.log('do layout');
				(this.$refs["table"] as any).doLayout()
			}, 200)
		},
		onTableHeaderChange(newWidth:number, _oldWidth:number, column:any) {
			// 先透传事件
			this.$emit("header-dragend", newWidth, _oldWidth, column)
			this.redrawTable()
			if (!this.operation) return
			const width = newWidth > this.columnMaxWidth ? this.columnMaxWidth : newWidth < 60 ? 60 : newWidth
				; (newWidth > this.columnMaxWidth || newWidth < 60) && $customSet(column, "width", width)
			this.operationComponent && this.operationComponent.onTableHeaderChange(width, column)
		},
		getColumnsStorage() {
			if (typeof window !== 'undefined') {
				this.projectPath = window.location.pathname.split("/").join("_")
				this.personCode = ""
				const cacheData = window.localStorage.getItem("tnCustomColumns")
				const cacheLineHeight = window.localStorage.getItem("tnCustomColumnsLineHeight")
				const key = `${this.cacheKey + this.projectPath}_${this.personCode || "0"}`
				if (cacheLineHeight) {
					const lineHeight = JSON.parse(cacheLineHeight)[key]
					this.lineHeight = lineHeight || this.lineHeight
				}
				if (cacheData) {
					const data = JSON.parse(cacheData)[key]
					if (data) {
						const dataMerge = data.map((item:any) => {
							const originItem:any = this.columns.find((i:any) => i.prop === item.prop)
							return {
								...item,
								...originItem,
							}
						})
						return dataMerge || this.columns
					}
					return data || this.columns
				}
			}
			return this.columns
		},
		// 打开customColumns弹框
		openCustomColumns() {
			if (!this.operationComponent.visibleDialog) {
				this.operationComponent.visibleDialog = true;
			}
		},
		createColumnOperation() {
			(this.operationComponent as any) = createApp(CustomColumns, {
				columns: this.customColumns,
				originColumns: this.columns,
				hiddenCustomIcon: this.hiddenCustomIcon,
				columnMaxWidth: this.columnMaxWidth,
				cacheKey: `${this.cacheKey + this.projectPath}_${this.personCode || "0"}`,
				onColumnsUpdate: this.onColumnUpdate
			}).use(ElementPlus).use(ComponentsPlus).mount(document.createElement("div"))
			setTimeout(() => {
				const tableHeaders = this.$el.querySelectorAll("table.el-table__header")
				tableHeaders.forEach((header:any) => {
					const tr = header.querySelector(`thead tr`)
					const th = tr.querySelectorAll("th.tq-table-header")
					const lastTh = th[th.length - 1] || {};
					if(!lastTh.classList.contains('is-hidden')) {
                        const cell = lastTh.querySelector(".cell")
                        cell && cell.appendChild(this.operationComponent.$el as never)
                    }
				})
			}, 400)
		},
		onColumnUpdate({ columns, lineHeight }:any) {
			console.log("columns-update");
			const columnsWithSelection = columns.map((item:any) => {
				if (item.type === "selection") {
					const originSelectionColumn:any = this.columns.find((i:any) => i.type === "selection")
					return {
						...item,
						...originSelectionColumn
					}
				} else {
					return {
						...item
					}
				}
			})
			$customSet(this, "lineHeight", lineHeight)
			$customSet(this, "customColumns", [])
			this.$nextTick(() => {
				$customSet(this, "customColumns", columnsWithSelection)
				this.createColumnOperation()
				this.redrawTable()
			})
		},
		// table原生方
		clearSelection(...theArguments:any) {
			(this.$refs["table"] as any).clearSelection(...theArguments)
		},
		toggleRowSelection(...theArguments:any) {
			(this.$refs["table"] as any).toggleRowSelection(...theArguments)
		},
		toggleAllSelection(...theArguments:any) {
			(this.$refs["table"] as any).toggleAllSelection(...theArguments)
		},
		toggleRowExpansion(...theArguments:any) {
			(this.$refs["table"] as any).toggleRowExpansion(...theArguments)
		},
		setCurrentRow(...theArguments:any) {
			(this.$refs["table"] as any).setCurrentRow(...theArguments)
		},
		clearSort(...theArguments:any) {
			(this.$refs["table"] as any).clearSort(...theArguments)
		},
		clearFilter(...theArguments:any) {
			(this.$refs["table"] as any).clearFilter(...theArguments)
		},
		doLayout(...theArguments:any) {
			(this.$refs["table"] as any).doLayout(...theArguments)
		},
		sort(...theArguments:any) {
			(this.$refs["table"] as any).sort(...theArguments)
		},
		// table原生方法结束
		getSelectLabel(value:any, options = []) {
			let label = ""
			for (let index = 0; index < options.length; index++) {
				const element:any = options[index]
				if (element.value === value) {
					label = element.label
					break
				}
			}
			return label
		},
		beforeAvatarUpload(file:any, scope:any, prop:any) {
			this.$emit("beforeAvatarUpload", file, scope, prop)
		},
		getSortData(sortObj:any) {
			// 判断两级父级是否是TqListView
			const parent:any = this.$parent
			if (parent && parent.$options && parent.$options.name === "TqListView") {
				parent.getSortData(sortObj)
			} else if (parent.$parent && parent.$parent.$options && parent.$parent.$options.name === "TqListView") {
				const grandFather:any = parent.$parent
				grandFather.getSortData(sortObj)
			}
		},
	},
}
</script>